/* eslint no-unused-vars: "error" */
import React, { useState } from 'react'
import { setCookie } from '@helpers/session'
import { analytics } from '@helpers/analytics'
import updateNewsletterSubscription from '@helpers/misc/updateNewsletterSubscription'
import { COOKIE_EXPIRE_1_YEAR } from '@consts/index'
import { FieldsLegalText } from './GDPR'
import { SubmitButtonState } from '@components/ui/Button/SubmitButton'
import { EmailForm } from '@components/newsletter/shared/EmailForm'
import { SubmitButton } from '@components/ui/Button'
import FooterNewsletterModal from '@components/newsletter/FooterNewsletterModal'
import styles from './styles.module.scss'

export default function NewsletterSection() {
  const [buttonState, setButtonState] = useState<SubmitButtonState>('ready')
  const [openedModal, setOpenedModal] = useState(false)
  const [formEmail, setFormEmail] = useState('')
  const [formErrors, setFormErrors] = useState<boolean>(false)

  const handleSubmit = async (email: string) => {
    setButtonState('loading')
    setFormErrors(false)

    try {
      const subcriptionFailed = await updateNewsletterSubscription({
        email,
        location: 'Footer'
      })

      if (subcriptionFailed) {
        setButtonState('ready')
      } else {
        setCookie('hideNewsletterPrompt', 'true', COOKIE_EXPIRE_1_YEAR)
        setOpenedModal(true)
        setFormEmail(email)
        setButtonState('success')
        analytics('Newsletter Sign Up', {
          email,
          label: 'footer',
          source: 'footer'
        })
        setButtonState('ready')
      }
    } catch (_) {
      setFormErrors(true)
      setButtonState('ready')
    }
  }

  return (
    <>
      <div className={styles.NewsletterSection}>
        <div className={styles.NewsletterSection__headline}>
          <h2 className={styles.NewsletterSection__headlineTitle}>
            Sign up to our <br className={styles.removeLine} /> (very good)
            SPOKE newsletter today
          </h2>
          <p>
            10% off your first order, and the scoop on new products and
            promotions.
          </p>
        </div>
        <div
          className={styles.NewsletterSection__form}
          data-testid="footer-newsletter"
        >
          <EmailForm onSubmit={handleSubmit}>
            {(_, isValid) => (
              <SubmitButton
                type="submit"
                fullWidth="never"
                size="small"
                variant="primary"
                disabled={!isValid}
                state={buttonState}
              >
                Sign Up
              </SubmitButton>
            )}
          </EmailForm>
          {formErrors && (
            <p className={styles.form__errors}>
              There was a problem subscribing, try again later.
            </p>
          )}
          <FieldsLegalText widthStyle="narrow" />
        </div>
      </div>
      {openedModal && (
        <FooterNewsletterModal
          openedModal={openedModal}
          onClose={() => setOpenedModal(false)}
          email={formEmail}
        />
      )}
    </>
  )
}
